import React, { useEffect, useRef, useState, useContext } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import pdf from "../../assets/pdf.png";

import { Grid } from "@mui/material";
import { Dropdown } from "react-bootstrap";
import VoucherCorporateScroll from "./VoucherCorporateScroll";
import VoucherCorporateContent from "./VoucherCorporateContent";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { voucherService } from "../../services/voucherService";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { SetVoucherListAtom, GetVoucherListAtom } from "../../store/voucherAtom";
import { IoPrintSharp } from "react-icons/io5";
import Tooltip from '@mui/material/Tooltip';

const VoucherCorDetailsPage = () => {
    const { id } = useParams();
    const [voucherDetails, setVoucherDetails] = useState({});
    const myPromiseModal = createModal(GeneralModal);
    const logicContext = useContext(LogicContext);
    const setVoucherAtomData = SetVoucherListAtom();
    const getVoucherAtomData = GetVoucherListAtom();

    // Ref for the printable content
    const printableRef = useRef();

    const navigate = useNavigate();
    const { pathname } = useLocation();
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

    useEffect(() => {
        document.title = "Voucher Details Page";
        loadCopVoucherDetails(id);

        return () => {
            //code here
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const loadCopVoucherDetails = (id) => {
        voucherService.corporateVoucherDetails(id).then(res => {
            if (res?.data?.length) {
                setVoucherDetails(res.data[0]);
                setVoucherAtomData(prev => {
                    return { ...prev, newVoucherList: res.data };
                });
            } else {
                setVoucherDetails({});
                setVoucherAtomData(prev => {
                    return { ...prev, newVoucherList: [] };
                });
            }
        });
    }

    // Custom print function similar to Chart of Account component
    const printSection = (elementRef, title = 'Voucher Details') => {
        if (!elementRef.current) {
            console.error('Print reference not found');
            return;
        }

        const printContents = elementRef.current.innerHTML;
        const originalContents = document.body.innerHTML;
        
        // Replace page content with selected section
        document.body.innerHTML = `
            <html>
                <head>
                    <title>${title}</title>
                    <style>
                        body { 
                            font-family: Arial, sans-serif; 
                            margin: 20px; 
                            line-height: 1.6;
                            color: #333;
                        }
                        table { 
                            border-collapse: collapse; 
                            width: 100%; 
                            margin: 20px 0;
                        }
                        th, td { 
                            border: 1px solid #ddd; 
                            padding: 12px 8px; 
                            text-align: left; 
                        }
                        th { 
                            background-color: #f8f9fa; 
                            font-weight: bold;
                            color: #495057;
                        }
                        .print-header { 
                            text-align: center; 
                            margin-bottom: 30px; 
                            border-bottom: 2px solid #6c757d;
                            padding-bottom: 20px;
                        }
                        .print-header h1 {
                            color: #6c757d;
                            margin: 0;
                            font-size: 28px;
                        }
                        .voucher-summary { 
                            background-color: #f8f9fa; 
                            padding: 20px; 
                            margin: 20px 0; 
                            border-left: 4px solid #6c757d;
                            border-radius: 5px;
                        }
                        .voucher-info {
                            background-color: #e9ecef;
                            padding: 15px;
                            margin: 15px 0;
                            border-radius: 8px;
                        }
                        .voucher-details {
                            margin: 10px 0;
                            font-size: 14px;
                        }
                        .voucher-details strong {
                            color: #495057;
                        }
                        .voucher-section {
                            margin: 20px 0;
                            border-top: 2px solid #dee2e6;
                            padding-top: 15px;
                        }
                        .voucher-list-header {
                            font-size: 18px;
                            font-weight: bold;
                            color: #495057;
                            margin: 20px 0 10px 0;
                            border-bottom: 1px solid #dee2e6;
                            padding-bottom: 5px;
                        }
                        .text-right {
                            text-align: right;
                        }
                        .text-center {
                            text-align: center;
                        }
                        .font-bold {
                            font-weight: bold;
                        }
                        .mb-3 {
                            margin-bottom: 1rem;
                        }
                        .mt-3 {
                            margin-top: 1rem;
                        }
                        .status-active {
                            color: #28a745;
                            font-weight: bold;
                        }
                        .status-inactive {
                            color: #dc3545;
                            font-weight: bold;
                        }
                        .amount-highlight {
                            font-size: 20px;
                            font-weight: bold;
                            color: #28a745;
                            margin: 10px 0;
                        }
                        .voucher-count {
                            font-size: 16px;
                            font-weight: bold;
                            color: #495057;
                        }
                        /* Hide any buttons or interactive elements */
                        button, .btn, .dropdown, .cursor, .show-cursor {
                            display: none !important;
                        }
                        /* Hide navigation elements */
                        .MuiSvgIcon-root, .p-1\\.5 {
                            display: none !important;
                        }
                        /* Print-specific adjustments */
                        @media print {
                            body {
                                margin: 0;
                                padding: 15px;
                                font-size: 12px;
                            }
                            .page-break {
                                page-break-before: always;
                            }
                            .no-print {
                                display: none !important;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-header">
                        <h1>Corporate Voucher Details</h1>
                        <p>Corporate Reference: ${voucherDetails?.Corporate_Ref_No || 'N/A'}</p>
                        <p>Voucher ID: ${voucherDetails?.Voucher_Id || id}</p>
                    </div>
                    ${printContents}
                </body>
            </html>
        `;
        
        // Trigger print dialog
        window.print();
        
        // Restore original content
        document.body.innerHTML = originalContents;
        window.location.reload(); // Reload to restore React functionality
    };

    // Print handler
    const handlePrint = () => {
        printSection(printableRef, `Voucher Details - ${voucherDetails?.Corporate_Ref_No || 'Corporate'}`);
    };

    const createNewVoucher = () => {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }

    const shareActionButtonAll = async (selectedIdList) => {
        if (selectedIdList.length < 1) {
            return logicContext.showToast(`No selection was made. Please select one or more vouchers`, "error");
        }
        await myPromiseModal({
            title: "Confirm Share action?", body: `A total of  ${selectedIdList?.length} Voucher(s)  will be allocated`,
            showInput: false, placeHolder: '',
        }).then((res) => {
            if (res.decision === true) {

                let xml_voucher = "";
                let temp = "";
                let cop_ref = '';

                let i = 0;
                let j = 0;
                let found = false;
                while (i < selectedIdList.length && j < getVoucherAtomData.newVoucherList.length) {
                    let voucherId = selectedIdList[i];
                    let voucher = getVoucherAtomData.newVoucherList[j];
                    if (voucher?.Ref_No === voucherId) {
                        cop_ref = voucher?.Corporate_Ref_No;
                        found = true;
                        temp += `<a>
                        <voucher_no>${voucher.Voucher_Number} </voucher_no>
                        <name>${voucher?.Reciepient_Name ? voucher?.Reciepient_Name : ''} </name>
                        <mobile>${voucher?.Reciepient_Mobile_Number ? voucher?.Reciepient_Mobile_Number : ''} </mobile>
                        <email>${voucher?.Reciepient_Email_Address ? voucher?.Reciepient_Email_Address : ''} </email>
                         </a>`;
                        i += 1;
                    }
                    j += 1;
                }

                if (!found) {
                    return logicContext.showToast(`Selected Voucher(s) does not exist in table List`, "");
                }

                xml_voucher = `<root> ${temp} </root>`;
                voucherService.shareVouchers({ ref_no: cop_ref, xml_voucher: xml_voucher.replace(/^\s+|\s+$/gm, '') }).then((res) => {

                    voucherService.voucherDetails(cop_ref).then(res => {
                        loadCopVoucherDetails(id);
                    });
                });
            }
        }).catch((err) => {
            logicContext.showToast("error submitting record", "error");
        });

    }

    return (
        <>
            <section className="mt-4">
                <div className="flex justify-end gap-2 mb-4">
                    <button
                        onClick={() => createNewVoucher()}
                        className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-opacity-50 transition-colors duration-200"
                    >
                        ADD NEW
                    </button>
                    <button
                        className="px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50 transition-colors duration-200"
                    >
                        Delete
                    </button>
                    
                    <Tooltip title="print voucher details">
                        <div
                            onClick={handlePrint}
                            className="p-1.5 rounded-md text-filterTextColor bg-filterColor cursor-pointer"
                        >
                            <IoPrintSharp className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
                        </div>
                    </Tooltip>
                </div>

                <div className="flex flex-col md:flex-row gap-4">
                    <div className="md:w-1/4">
                        <VoucherCorporateScroll />
                    </div>
                    
                    {/* Printable content wrapper */}
                    <div className="md:w-3/4" ref={printableRef}>
                        <section className="w-full">
                            {/* Voucher Summary for Print */}
                            <div className="voucher-summary">
                                <div className="voucher-info">
                                    <div className="voucher-details">
                                        <strong>Corporate Reference:</strong> {voucherDetails?.Corporate_Ref_No}
                                    </div>
                                    <div className="voucher-details">
                                        <strong>Voucher ID:</strong> {voucherDetails?.Voucher_Id}
                                    </div>
                                    <div className="voucher-details">
                                        <strong>Creation Date:</strong> {voucherDetails?.Creation_Date}
                                    </div>
                                    <div className="voucher-details">
                                        <strong>Status:</strong> 
                                        <span className={voucherDetails?.Status === 'Active' ? 'status-active' : 'status-inactive'}>
                                            {` ${voucherDetails?.Status || 'N/A'}`}
                                        </span>
                                    </div>
                                </div>

                                {voucherDetails?.Total_Amount && (
                                    <div className="amount-highlight">
                                        Total Amount: {voucherDetails?.Currency_Symbol || ''}{voucherDetails?.Total_Amount}
                                    </div>
                                )}

                                {getVoucherAtomData?.newVoucherList?.length > 0 && (
                                    <div className="voucher-count">
                                        Total Vouchers: {getVoucherAtomData.newVoucherList.length}
                                    </div>
                                )}

                                <div className="voucher-list-header">
                                    Voucher List
                                </div>
                            </div>

                            <VoucherCorporateContent
                                newVoucherList={getVoucherAtomData.newVoucherList}
                                voucherDetails={voucherDetails}
                                shareActionButtonAll={shareActionButtonAll}
                            />
                        </section>
                    </div>
                </div>
            </section>
        </>
    );
};

export default VoucherCorDetailsPage;